import { render, staticRenderFns } from "./EditcCreate.vue?vue&type=template&id=215d6d02"
import script from "./EditcCreate.vue?vue&type=script&lang=js"
export * from "./EditcCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports